import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopSearch(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input pop_search">
      <h2 className="pop_tit">검색 등록하기</h2>
      <div className="content_container scroll">
        <hr className="com_divider" />
        <div className="com_radio_wrap">
          <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
          <label htmlFor="rdo01">전체</label>
          <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
          <label htmlFor="rdo02">학생</label>
          <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
          <label htmlFor="rdo03">교사</label>
          <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
          <label htmlFor="rdo04">담임 </label>
          <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
          <label htmlFor="rdo04">관리자 </label>
        </div>
        <hr className="com_divider" />

        <section className="search search_top">
          <input type="search" placeholder="검색" className="input s type_search" />
          <button className="com_btn gray ws s icon_search"></button>
        </section>
        <section className="com_board_list__scroll">
          <table className="com_board_list">
            <colgroup>
              <col width="50" />
              <col width="70" />
              <col width="100" />
              <col width="auto" />
            </colgroup>
            <thead>
              <tr>
                <th>No</th>
                <th>비고</th>
                <th>이름</th>
                <th>연락처</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(10)].map((_, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>학생</td>
                  <td>홍길동123</td>
                  <td className="td_point">010-1234-1324</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopSearch;
